import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { FormSection } from '../../form/FormSection';
import { FORM_STYLES } from '../../../styles/formStyles';
import { FormValues } from '../CreateStep1V3';

interface MiscellaneousSectionProps {
  values: FormValues;
  handleChange: (name: string) => (value: any) => void;
  onBlur?: (fieldName: string) => () => void;
}

export const MiscellaneousSection: React.FC<MiscellaneousSectionProps> = ({
  values,
  handleChange,
  onBlur
}) => {
  return (
    <FormSection
      icon={MoreHoriz}
      iconColor="#62B8E9"
      title="Övrigt"
    >
      <Box sx={{ mt: 2 }}>
        <Typography sx={FORM_STYLES.label}>
          Vad som ingår/inte ingår
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={values.miscellaneousNotes || ''}
          onChange={(e) => handleChange('miscellaneousNotes')(e.target.value)}
          onBlur={onBlur?.('miscellaneousNotes')}
          placeholder="T.ex. förråd, garage, fastighetsskatt..."
          autoComplete="off"
          sx={{
            ...FORM_STYLES.input.base,
            mt: 1,
            '& .MuiInputBase-input::placeholder': {
              color: '#9CA3AF',
              opacity: 1
            }
          }}
        />
      </Box>
    </FormSection>
  );
}; 
